export default function Logo({ handleNavigate }) {

  const BACK_URL = process.env.REACT_APP_BACKEND_URL
  const logoBlack = `${BACK_URL}/media/home/dnzify-logo-black.png`;
  const logoBlackHorizontal = `${BACK_URL}/media/home/dnzify-logo-black-horizontal.png`;

  return (

    <div className='nav-item-logo' onClick={() => handleNavigate('/')}>

      <a href="https://www.dnzify.com" target="_blank" rel="noopener noreferrer">
        <img
          src={logoBlackHorizontal}
          alt="Dnzify Logo"
          style={{ marginTop: '0.5em', maxHeight: "40px", objectFit: "contain" }}
        />
      </a>


    </div>
  )
}